module.exports = __webpack_public_path__ + "img/product-placeholder-1.e89c5e8.png";